import { Nurse, Aide, Volunteer, SocialWorker, Spiritual } from './roleData'; // This is from widgetconfig.json in dashboard
// API/Database.ts

export const COUCHDB_POLL_INTERVAL = 60000; // HTTP Status Codes:

export const HTTP_STATUS_OK = 200; // ClearScripts Server API Constants

export const MAINT_STATUS_COMPLETE = 'complete';
export const MAINT_STATUS_PENDING = 'pending';
export const MAINT_ORDER_TYPE_VERBAL = 'verbal';
export const MAINT_ORDER_TYPE_ADMIT = 'admit';
export const CLEARSCRIPTS_CLIENT = 'clearscripts-client';
export const MED_ORDER_TYPE_START = 'start';
export const MED_ORDER_TYPE_STOP = 'stop';
export const MED_IS_CURRENT_VERSION_TRUE = 'y';
export const MED_IS_CURRENT_VERSION_FALSE = 'n';
export const MED_IS_RCOPIA_DELETED_TRUE = 'y';
export const MED_IS_RCOPIA_DELETED_FALSE = 'n';
export const RCOPIA_STOPREASON_DELETED = 'deleted';
export const MED_SERIES_START_INDEX = '0'; // IDG

export const IDGData = 'IDGDATA'; // Cert-app

export const Certification = 'Certification'; // ClearScripts Printing

export const AllMedications = 'All';
export const ActiveMedications = 'Active';
export const ActiveAndMaintainedMeds = 'Active with Mods'; // DocLink Printing

export const Card = 'Card';
export const Listing = 'Listing'; // Manifest Printing

export const Contents = 'Contents';
export const TabularView = 'Tabular'; // Option to print Notes

export const Notes = 'Notes';
export const Orders = 'Orders';
export const GeneralNotes = 'General Notes'; // Print

export const print = 'print'; // IDG

export const idg = 'idg';
export const uppercaseIdg = 'IDG'; // Widget Names

export const Bereavement = 'Bereavement';
export const CarePlanFrequency = 'CarePlanFrequency';
export const CarePlanProblems = 'CarePlanProblems';
export const CompletedForms = 'CompletedForms';
export const ClearScripts = 'ClearScripts';
export const DocLink = 'DocLink';
export const Facesheet = 'Facesheet';
export const Forms = 'Forms';
export const HospiceItemSet = 'HospiceItemSet';
export const IDGDocument = 'IDGDocument';
export const Manifest = 'Manifest';
export const Measures = 'Measures';
export const PatientsListing = 'PatientsListing';
export const PatientAssistance = 'PatientAssistance';
export const ProgressNotes = 'ProgressNotes';
export const ScheduledVisits = 'ScheduledVisits';
export const VisitLog = 'VisitLog';
export const VisitSummary = 'VisitSummary'; // Care Plan Problems

export const NONE = 'NONE';
export const ANSWERED = 'ANSWERED';
export const ALL = 'ALL'; // Care Plan Problems and Forms

export const Submitted = 'Submitted';
export const InProgress = 'In Progress';
export const Autosave = 'Autosave';
export const Discard = 'Discard';
export const Created = 'Created';
export const Edit = 'Edit';
export const Delete = 'Delete';
export const Resolve = 'Resolve';
export const View = 'View'; // Forms

export const FAJITA = 'FAJITA';
export const FORMIO = 'FORMIO'; // Task

export const ACTIVE = 'Active';
export const DISCONTINUED = 'Discontinued';
export const PENDING = 'Pending'; // Permissions

export const ROLE_HOSPICE_ADMIN = 'ROLE_HOSPICE_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN'; // Printing Notes manifest

export const IDG_MEETING_REVIEW = 'IDG MEETING REVIEW'; // Attending Physician

export const ATTENDING_PHYSICIAN = 'ATTENDING_PHYSICIAN'; // Geolocation

export const GEOLOCATION_PERMISSION_DENIED = 1; // Tasks

export const includedc = 'true'; // Misc.

export const STRING_TRUE = 'true';
export const STRING_FALSE = 'false'; // QCodes

export const Q5001 = 'Q5001';
export const Q5006 = 'Q5006';
export const Q5010 = 'Q5010';
export const GIPQCODES = [Q5006, Q5010]; // LOC

export const DIRECT_CARE = 'DIRECT_CARE'; // Progress Notes Printing & ReactPDF

export const Both = 'Both';
export const emptyNoteText = ' ';
export const emptyText = '';
export const OnePerPage = 'One per page';
export const MultiPerPage = 'Multi per page'; // Dashboard & Progress Notes

export const PRNRoles = [{
  name: Nurse,
  key: 'prnnurse'
}, {
  name: SocialWorker,
  key: 'prnsocialworker'
}, {
  name: Spiritual,
  key: 'prnspiritual'
}, {
  name: Aide,
  key: 'prnaide'
}, {
  name: Volunteer,
  key: 'prnvol'
}]; // Facility and Standing Orders

export const PSO = 'PSO';
export const PSOHome = 'PSO-H';
export const PSOFacility = 'PSO-F'; // get Physician

export const cert = 'cert'; // Measures ReactPDF

export const Graphs = 'Graphs';
export const Listings = 'Listings';
export const scores = 'scores'; // Task

export const week = 'week'; // IDG + Dashboard + Forms

export const LCD_NGS = 'LCD-NGS';
export const LCD_PGBA = 'LCD-PGBA';
export const idgLcdString = 'idg-lcd';
export const idgPgbaString = 'idg-pgba';
export const lowercaseT = 't';
export const ComprehensiveAssessment = 'Comprehensive Assessment'; // ReactPDF

export const ReactPDFString = 'ReactPDF'; // API status

export const info = 'info';
export const error = 'error';
export const success = 'success'; // programSiteName

export const Hospice = 'Hospice';
export const PalliativeCare = 'Palliative Care';
/**
HP   | Hospice
PD   | Private Duty
PC   | Palliative Care
NE   | Non-enrolled Hospice
CM   | Medicare Care Choice Model
CB   | Community Bereavement
HH   | Home Health
LT   | Long Term Referral
PM   | Palliative Management
*/
// Suggest Box

export const emptyOption = {
  id: '',
  label: '',
  value: ''
}; // Visits

export const SmartChart = 'SMARTCHART';
export const SmartChartIPU = 'SMARTCHART_IPU'; // Order Type

export const CPF = 'CPF';
export const cppEditingAllowedRoleGroup = ['Administration', 'Bereavement', 'Care Coordinator (MCCM)', 'Dietary', 'DMS', 'Doctor', 'Doula', 'Executive', 'Family Counseling', 'Finance', 'HIS', 'IDG Team Roles', 'Massage Therapist', 'Mental Health Counseling', 'Music Therapist', 'Nurse', 'Occupational Therapy', 'Other Counselor (MCCM)', 'Other Therapist (MCCM)', 'Pharmacy', 'Physical Therapy', 'Sales And Marketing', 'Social Worker', 'Speech Therapy', 'Spiritual', 'Surveyor, Therapist'];